<app-header-three></app-header-three>
<app-breadcrumbs image="assets/img/doacoes.jpg" text="Ajude o Amal a levar esperança a mais crianças"></app-breadcrumbs>
<app-content></app-content>
<footer class="sigma_footer footer-2 bg-cover bg-center bg-transparent light-overlay"
        [style.background-image]="'url(assets/img/fundo_footer.jpg)'">
    <app-footer></app-footer>
</footer>
